import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { MemberProfiles, MemberProfile } from 'bff/models/member';
import { Secques, Nationalitys, Occupations, Postcodes, EmailDomains, Codes } from 'bff/models/info';
import { BaseRes } from 'bff/models/base/baseRes';
import { MemberMaintain } from 'constants/models/components/memberMaintain';
import _ from 'lodash';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { CodeClass } from 'constants/enums/codeClass.enum';

/**
 * @description 會員資料維護頁初始設定資料方法
 * @param memberId 會員 Id
 */
const fetchInitSetting = async (memberId:string):Promise<MemberMaintain> => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const fetchMemberProfileReq = commonService.getApiReqData({ MEMBER_ID: memberId });

  const result = Promise.all([
    apiService.fetchSecque(baseReq, reqConfig),
    apiService.fetchNationality(baseReq, reqConfig),
    apiService.fetchOccupation(baseReq, reqConfig),
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchEmailDN(baseReq, reqConfig),
    apiService.fetchMemberProfile(fetchMemberProfileReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.TIP),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([secquesRes, nationalityRes, occupationsRes, postcodesRes, emailDNsRes, memberProfileRes, tipCodeRes, UICodeRes]) => {
    const secquesBaseRes:BaseRes<Secques> = { ...secquesRes };
    const nationalityBaseRes:BaseRes<Nationalitys> = { ...nationalityRes };
    const occupationsBaseRes:BaseRes<Occupations> = { ...occupationsRes };
    const postcodesBaseRes:BaseRes<Postcodes> = { ...postcodesRes };
    const emailDNsBaseRes:BaseRes<EmailDomains> = { ...emailDNsRes };
    const memberProfileBaseRes:BaseRes<MemberProfiles> = { ...memberProfileRes };
    const tipCodeBaseRes:BaseRes<Codes> = { ...tipCodeRes };
    const UICodeBaseRes:BaseRes<Codes> = { ...UICodeRes };

    const res:MemberMaintain = {
      secques: commonService.arrayTypeReturn(secquesBaseRes.TRANRS.SECQUE),
      nationalitys: commonService.arrayTypeReturn(nationalityBaseRes.TRANRS.NATIONALITY),
      occupations: commonService.filterOccupationOpts(commonService.arrayTypeReturn(occupationsBaseRes.TRANRS.OCCUPATION)),
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      emailDomains: commonService.arrayTypeReturn(emailDNsBaseRes.TRANRS.EMAILDN),
      memberProfile: _.find(memberProfileBaseRes.TRANRS.MEMBER, (memberProfile:MemberProfile) => memberProfile.MEMBER_ID === memberId) as MemberProfile,
      tipCode: commonService.arrayTypeReturn(tipCodeBaseRes.TRANRS.CODES),
      UICode: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 會員維護-更新方法
 * @param memberId 會員 Id
 * @param memberProfile 會員資料
*/
const updateMemberProfile = async (memberId:string, memberProfile:MemberProfile) => {
  const baseReq = commonService.getApiReqData({ MEMBER: memberProfile });
  const reqConfig = commonService.getReqConfig();

  const result = await apiService.updateMemberProfile(baseReq, reqConfig).then((res:BaseRes<any>) => res);

  if (result.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.error(result.MWHEADER.RETURNDESC);
  } else {
    return result.TRANRS?.MEMBER.SN !== '';
  }
};

export default {
  fetchInitSetting,
  updateMemberProfile
};
